export default __webpack_public_path__ + "static/media/arrow2.21504d6b.svg";